"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGuardRedirectService = void 0;
const router_1 = require("@angular/router");
const of_1 = require("rxjs/internal/observable/of");
const operators_1 = require("rxjs/operators");
const account_service_1 = require("./account.service");
/**
 *  Redirect Auth Guard Service
 *
 * Checks if the user has the access to component and redirects to accessible path
 */
class AuthGuardRedirectService {
    constructor(router, accountService) {
        this.router = router;
        this.accountService = accountService;
    }
    canActivate(route, state) {
        return this.accountService.getAccountDetails(true).pipe(operators_1.map((res) => {
            this.isPrepaid = res.advancePayAccount;
            if (this.isPrepaid) {
                this.router.navigate(['/prepaid/billing']);
            }
            else {
                return true;
            }
        }), operators_1.catchError((err) => {
            this.router.navigate(['/wireless']);
            return of_1.of(false);
        }));
    }
}
exports.AuthGuardRedirectService = AuthGuardRedirectService;
//# sourceMappingURL=authguardredirect.service.js.map